/**
 * SavedOrderIndicator Component
 * Shows a small badge when a customer has saved orders for a restaurant
 */

import React from 'react';
import { BookMarked } from 'lucide-react';

const SavedOrderIndicator = ({ count = 1, className = '' }) => {
  if (!count || count === 0) return null;

  return (
    <div
      className={`inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-medium ${className}`}
      title={`${count} saved ${count === 1 ? 'order' : 'orders'} for this restaurant`}
    >
      <BookMarked className="w-3 h-3" />
      <span>{count} Saved {count === 1 ? 'Order' : 'Orders'}</span>
    </div>
  );
};

export default SavedOrderIndicator;
